module.exports = __webpack_public_path__ + "static/img/Sirui_WANG.eae8c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Sirui_WANG.png
// module id = BiY9
// module chunks = 1